import {AppUrls} from 'shared/config/model/urls';

import React, {useState} from 'react';
import {t} from '@lingui/core/macro';
import cn from 'classnames';

import Message from 'shared/ui/icons/Message';
import SupportChat from 'shared/ui/icons/SupportChat';
import Telegram from 'shared/ui/icons/Telegram';
import VKButtonIcon from 'shared/ui/icons/VKButtonIcon';
import MaxChat from 'shared/ui/icons/MaxChat';
import MoreActions from 'shared/ui/MoreActions/MoreActions';
import {SupportModal} from 'features/support';
import { isTranslate } from 'shared/lib/lang';

import {PALETTE} from 'shared/config/model/palette';

import styles from './ButtonSetting.module.scss';

const ButtonSetting: React.FC = () => {
    const [isOpenModal, setIsOpenModal] = useState(false);

    const handleModalOpen = () => setIsOpenModal(true);

    const handleModalClose = () => setIsOpenModal(false);

    const openLink = (url: string) => () => window.open(url, '_blank', 'noopener,noreferrer');

    const anchor = (
        <button
            className={cn(
                styles.button,
                styles.colorButton,
            )}
            title={t`Написать в техподдержку`}
            aria-label={t`Написать в техподдержку`}
        >
            <Message/>
        </button>
    );

    const contacts = [
        {
            key: 'max',
            label: t`Написать в Max`,
            icon: <MaxChat/>,
            onClick: openLink(AppUrls.SUPPORT_MAX),
        },
        {
            key: 'telegram',
            label: t`Написать в Telegram`,
            icon: <Telegram color={PALETTE.telegram}/>,
            onClick: openLink(AppUrls.TELEGRAM),
        },
        {
            key: 'vk',
            label: t`Написать в VK`,
            icon: <VKButtonIcon/>,
            onClick: openLink(AppUrls.SUPPORT_VK),
        },
        {
            key: 'support',
            label: t`Написать в форму на сайте`,
            icon: <SupportChat/>,
            onClick: handleModalOpen,
        },
    ].filter(({key}) => !isTranslate() || key === 'support' || key === 'telegram');

    return (
        <>
            <MoreActions anchor={anchor} placement="leftEnd">
                <div className={styles.menuHeader}>{t`Написать в службу поддержки`}</div>
                {contacts.map(({key, label, icon, onClick}) => (
                    <div key={key} className={styles.menuItem} onClick={onClick}>
                        <span className={styles.menuItemIcon}>{icon}</span>
                        <span className={styles.menuItemLabel}>{label}</span>
                    </div>
                ))}
            </MoreActions>
            <SupportModal open={isOpenModal} handleClose={handleModalClose} />
        </>
    );
};

export default ButtonSetting;